module.exports = __webpack_public_path__ + "img/ic_upload_cloud.00889da8.svg";